import React, { useState } from "react";
import { Form } from "rsuite";

import {
  ContactDetails,
  IdentificationDetails,
  PermanentAddress,
  PersonalInformation,
  TemporaryAddress,
  ProfessionInfromation,
  BankDetails,
  LandlordDetails,
  FamilyDetails,
  Documents,
} from "../../components/form/kyc";

const Kyc = () => {
  const [formValue, setFormValue] = useState({});
  return (
    <div className="shadow bg-white rounded-lg p-4 mb-5">
      <Form fluid>
        <section className="mb-3 personal-information">
          <h3>Personal Information</h3>
          <PersonalInformation />
        </section>
        <section className="mb-3 contact-details">
          <h3>Contact Details</h3>
          <ContactDetails />
        </section>
        <section className="mb-3 permanemt-address">
          <h3>Permanent Address</h3>
          <PermanentAddress />
        </section>
        <section className="mb-3 temporary-address">
          <h3>Temporary Address</h3>
          <TemporaryAddress />
        </section>
        <section className="mb-3 identification-details">
          <h3>Identification Details</h3>
          <IdentificationDetails />
        </section>
        <section className="mb-3 qualification">
          <h3>Qulaification</h3>
          <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
            <Form.Group>
              <Form.ControlLabel>Education Level</Form.ControlLabel>
              <Form.Control name="Education Level" />
            </Form.Group>
          </div>
        </section>
        <section className="mb-3 associated-profession/information">
          <h3>Associated Profession/Information</h3>
          <ProfessionInfromation />
        </section>
        <section className="mb-3 bank-details">
          <h3>Bank Details</h3>
          <BankDetails />
        </section>
        <section className="mb-3 family-details">
          <h3>Family Details </h3>
          <FamilyDetails />
        </section>
        <section className="mb-3 Landlord-details">
          <h3>Landlord/Owner Details </h3>
          <LandlordDetails />
        </section>
        <section className="mb-3 documents">
          <h3>Documents</h3>
          <Documents />
        </section>
      </Form>
    </div>
  );
};

export default Kyc;
